import { Box } from '@mui/material';
import { ViewBillContentSection } from 'components/bill/ui/ViewBill/ViewBillContentSection';
import { CouponInput } from 'components/order/coupons/CouponInput';
import { CouponItem } from 'components/order/coupons/CouponItem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IAdjustmentReadResourceV22, IBasketAdjustment } from '../model/Basket';

interface BasketCouponsProps {
    onAdd: (coupon: string) => void;
    coupons?: (IAdjustmentReadResourceV22 | IBasketAdjustment)[];
    loading?: boolean;
    onRemove: (coupon: string) => void;
}

export const BasketCoupons: React.FC<React.PropsWithChildren<BasketCouponsProps>> = ({
    onAdd,
    onRemove,
    coupons,
    loading
}) => {
    const { t } = useTranslation();
    const handleRemoveCoupon = React.useCallback(
        (coupon?: string) => {
            if (coupon) {
                onRemove(coupon);
            }
        },
        [onRemove]
    );
    const renderCoupon = React.useCallback(
        (adjustment: IAdjustmentReadResourceV22 | IBasketAdjustment) => (
            <CouponItem onClick={handleRemoveCoupon} adjustment={adjustment} key={adjustment.couponCode} />
        ),
        [handleRemoveCoupon]
    );
    if (loading) {
        return null;
    }
    return (
        <ViewBillContentSection title={t('CHECKOUT_COUPON_TITLE')} bottomSpacing={2}>
            <Box>{coupons?.map(renderCoupon)}</Box>
            <Box mt={2}>
                <CouponInput onAdd={onAdd} />
            </Box>
        </ViewBillContentSection>
    );
};
